<div class="overlay" *ngIf="isLoading">
    <div class="spinner-content">
      <div class="spinner-border text-gray-700" role="status"></div>
  
      @if(spinnerMsg){
        <p class="small text-gray-700">{{ spinnerMsg }}...</p>
      }@else{
        <p class="small text-gray-700">Loading...</p>
      }
    </div>
  </div>
  
